<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" width="600" v-model="dialog">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Chi Tiết Đơn báo nghỉ
        <v-spacer></v-spacer>
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-4">
        <div>Ngày {{ getCurrentDate }}</div>

        <v-row>
          <v-col cols="6" class="pl-1">
            <CardStudentName :student="absentRequestDetail.student" />
          </v-col>
          <v-col class="d-flex justify-space-between align-center" cols="6">
            <div>
              <p class="text-caption my-0">Ngày sinh</p>
              <span>{{ absentRequestDetail.student.dob | ddmmyyyy }}</span>
            </div>
            <div>
              <p class="text-caption my-0">Mã số</p>
              <span>{{ absentRequestDetail.student.code | getStudentCode }}</span>
            </div>
            <div>
              <p class="text-caption my-0">Lớp</p>
              <span>{{ absentRequestDetail.studentClass.title }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" md="12" class="pt-3 pb-10">
          <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
            <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray font-weight-bold">
              Lý do xin nghỉ:
            </v-col>
            <v-col cols="12" md="4" class="pb-0 text-sm-body-4">
              {{ absentRequestDetail.reason }}
            </v-col>
          </v-col>
          <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
            <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray font-weight-bold">
              Trạng thái:
            </v-col>
            <v-col cols="12" md="4" class="pb-0 text-sm-body-4">
              {{ absentRequestDetail.status | absentRequestStatus }}
            </v-col>
          </v-col>
          <v-col v-if="absentRequestDetail.status !== 'created'" cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
            <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray font-weight-bold">
              Người phê duyệt:
            </v-col>
            <v-col cols="12" md="4" class="pb-0 text-sm-body-4">
              {{ absentRequestDetail.data.name }}
            </v-col>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName'
import moment from 'moment'
export default {
  components: {
    CardStudentName
  },
  data() {
    return {
      dialog: false
    }
  },
  props: {
    state: Boolean,
    absentRequestDetail: Object
  },
  computed: {
    getCurrentDate() {
      return moment(this.absentRequestDetail.date).format('DD/MM/YYYY')
    }
  },
  methods: {
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(newState) {
      this.dialog = true
    }
  }
}
</script>
